import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import selectComposeInput from "./src/select-compose-input.vue";
import selectLikeInput from "./src/select-like-input.vue";
import selectComposeDatePicker from "./src/select-compose-date-picker.vue";
export const xInputComposeSelect = withInstall(selectComposeInput, {
  selectLikeInput,
  selectComposeDatePicker,
});
export default xInputComposeSelect;
export const xSelectLikeInput = withNoopInstall(selectLikeInput);
export const xSelectComposeDatePicker = withNoopInstall(
  selectComposeDatePicker
);
export * from "./src/select-compose-input";
export * from "./src/select-like-input";
export * from "./src/select-compose-date-picker";
